import type { ScopedAssignment as ScopedAssignmentModel } from '@/adapters/catalogv1.g';

export function extractScopedAssignment(model: ScopedAssignmentModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    roleRef: model.role_ref ?? '',
    scopeRef: model.scope_ref ?? '',
    scopeKind: model.scope_kind ?? '',
    condition: model.condition ?? '',
    conditionTitle: model.condition_title ?? '',
    expiresAt: model.expires_at ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogScopedAssignment = ReturnType<
  typeof extractScopedAssignment
>;
